import { KalaWalletKey } from '../../../models/wallet.model';

/**
 * The wallets in the order the balance card lists them, per the handoff: گواهی سپرده,
 * اصلی, انبار, اختیار معامله, آتی کالا.
 */
export const WALLET_BALANCE_ORDER = [
	'CDC',
	'Main',
	'WareHouse',
	'Option',
	'Future'
] as const satisfies readonly KalaWalletKey[];

/** The two wallets the card always lists; the rest fold under «سایر». */
export const WALLET_BALANCE_PRIMARY_KEYS: readonly KalaWalletKey[] = ['CDC', 'Main'];

export const WALLET_BALANCE_LABELS: Record<KalaWalletKey, string> = {
	CDC: 'گواهی سپرده',
	Main: 'اصلی (قابل برداشت)',
	WareHouse: 'انبار',
	Option: 'اختیار معامله',
	Future: 'آتی کالا'
};

/** The grey «سایر» is drawn in, as one slice on the bar and as its legend swatch. */
export const WALLET_BALANCE_OTHERS_COLOR = 'bg-gray-300';

/** How far «تراکنش‌های اخیر» scrolls down before the card folds its breakdown away, in px. */
export const WALLET_BALANCE_COLLAPSE_THRESHOLD = 24;

/** The least scroll, in px, read as a change of direction — less is a finger's jitter. */
export const WALLET_BALANCE_SCROLL_DEAD_ZONE = 6;

/**
 * The vertical padding, in px, the balance card sheds as it folds: `py-3` (12px a side)
 * down to `py-1.5` (6px a side). Keep in step with the card's template.
 */
export const WALLET_BALANCE_FOLD_PADDING = 12;

/** The other wallets share «سایر»'s grey. */
export const WALLET_BALANCE_COLORS: Record<KalaWalletKey, string> = {
	CDC: 'bg-green-500',
	Main: 'bg-purple-500',
	WareHouse: 'bg-gray-300',
	Option: 'bg-gray-300',
	Future: 'bg-gray-300'
};
